import cn from 'classnames'
import {FC, useState} from 'react'

import {theme} from '@/theme/theme'

import {FilePreviewModal} from '../modal/FilePreviewModal'
import {ModalWrapper} from '../modal/ModalWrapper'

type TrademarkLogoPreviewProps = {
  imageData: {
    name: string
    url: string
  }[]
  justify?: 'flex-start' | 'center' | 'flex-end'
  maxHeight?: string
  isPreviewEnabled?: boolean
  hasPreviewBorder?: boolean
  showMultiple?: boolean
}

export const TrademarkLogoPreview: FC<TrademarkLogoPreviewProps> = ({
  imageData,
  justify = 'center',
  maxHeight = '40px',
  isPreviewEnabled = false,
  hasPreviewBorder,
  showMultiple = false,
}) => {
  const [activeLogo, setActiveLogo] = useState<string | null>(null)
  const logos = showMultiple ? imageData : imageData.slice(0, 1)

  return (
    <>
      <div className="wrapper">
        {logos.map(({name, url}) => (
          <div
            key={url}
            className={cn('wrapper logo-wrapper', isPreviewEnabled && 'clickable')}
            role="button"
            tabIndex={0}
            onClick={(e) => {
              if (isPreviewEnabled) {
                e.stopPropagation()
                e.preventDefault()
                setActiveLogo(url)
              }
            }}
          >
            <img src={url} alt={name} className={cn('logo', hasPreviewBorder && 'outlined')} />
          </div>
        ))}
      </div>
      <ModalWrapper
        isVisible={isPreviewEnabled && Boolean(activeLogo)}
        props={
          activeLogo
            ? {
                uploadedFile: activeLogo,
                closeModal: (e: any) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setActiveLogo(null)
                },
              }
            : null
        }
      >
        {(props) => <FilePreviewModal {...props} />}
      </ModalWrapper>

      <style jsx>{`
        .wrapper {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: ${theme.spacing[2]};
          height: 100%;
        }

        .logo {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: ${maxHeight};
          object-fit: contain;
          object-position: ${justify === 'flex-start'
            ? 'left'
            : justify === 'center'
            ? 'center'
            : 'right'};
        }

        .clickable {
          cursor: zoom-in;
        }
        .outlined {
          padding: ${theme.spacing[1]};
          border-radius: 4px;
          box-shadow: inset 0 0 0 1px ${theme.palette.gray[200]};
        }
      `}</style>
    </>
  )
}
